import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ByobMyServicesComponent } from './byob-my-services.component';
import { MatDividerModule } from '@angular/material/divider';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { ByobSandboxCardComponent } from './byob-sandbox-card/byob-sandbox-card.component';
import { ByobServiceCardComponent } from './byob-service-card/byob-service-card.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import {MatProgressBarModule} from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    ByobMyServicesComponent,
    ByobSandboxCardComponent,
    ByobServiceCardComponent
  ],
  imports: [
    CommonModule,
    MatDividerModule,
    SharedModule,
    IconsModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    MatProgressBarModule
  ],
  exports: [
    ByobMyServicesComponent,
    ByobServiceCardComponent,
    ByobSandboxCardComponent
  ]
})
export class ByobMyServicesModule { }
